import { animate, scroll, spring, timeline } from 'motion';

export default function HomepageHero() {
  const heroTitle1 = document.querySelector('#summer-2025-nature');
  const heroTitle2 = document.querySelector('#summer-2025-makes-us');
  const heroBG = document.querySelector('[data-el="hero-bg"]');
  const heroBgParallax = document.querySelector('[data-el="hero-bg-parallax"]');
  const heroBottle = document.querySelector(
    '[data-el="hero-bottle-summer-2025"]'
  );
  const heroTagline = document.querySelector('[data-el="hero-tagline"]');
  const heroCTA = document.querySelector('[data-el="hero-cta"]');

  // Hero BG parallax
  scroll(animate(heroBgParallax, { y: [0, 600] }));

  const droplets = document.querySelector('[data-el="droplet-container"]');

  // hide first droplet
  const droplet1 = droplets.querySelector('[data-el="droplet"]:nth-child(1)');
  const droplet5 = droplets.querySelector('[data-el="droplet"]:nth-child(5)');

  // hide droplets
  droplet1.style.opacity = 0;
  droplet5.style.opacity = 0;

  const animateBottleOpacity = [
    heroBottle,
    { scale: [0.85, 1] },
    {
      duration: 4,
      ease: 'easeInOut',
    },
  ];

  const animateTitle1Opacity = [
    heroTitle1,
    { opacity: [0, 1] },
    {
      duration: 1,
      at: '<',
    },
  ];
  const animateTitle2Opacity = [
    heroTitle2,
    { opacity: [0, 1] },
    {
      duration: 1,
      delay: 1,
      at: '<',
    },
  ];

  // Tagline animation
  const animateTagline = [
    heroTagline,
    { opacity: [0, 1] },
    { duration: 0.5, at: '0.5' },
  ];
  const animateTaglineOpacity = [
    heroTagline,
    { opacity: [0, 1] },
    {
      duration: 0.5,
    },
  ];

  // CTA animation
  const animateCTA = [heroCTA, { opacity: [0, 1] }, { duration: 0.5 }];

  const sequence = [
    animateBottleOpacity,
    animateTitle1Opacity,
    animateTitle2Opacity,
    animateTagline,
    animateCTA,
  ];

  timeline(sequence, {
    delay: 1,
  });

  // VIDEO FALLBACK
  // Check if the video is supported

  const video = document.querySelector('[data-el="hero-bg"]');
  const fallbackContainer = document.querySelector(
    '[data-el="hero-bg-fallback"]'
  );
  const fallbackSrc = fallbackContainer?.dataset?.path;

  video.play().catch(() => {
    // Autoplay failed (most likely Safari on Low Power mode) — hide video or show fallback
    if (fallbackContainer && fallbackSrc) {
      const img = new Image();
      img.src = fallbackSrc;
      img.alt = 'Fallback background';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.display = 'block';
      fallbackContainer.appendChild(img);
    }
    video.style.display = 'none';
  });
}
